import { useTranslations } from 'next-intl';
import React from 'react';
import FactionPlayerCard from '../FactionPlayerCard';
import {
  Carousel,
  CarouselContent,
  CarouselIndicator,
  CarouselItem,
} from '@wwe-portal/ui/components/carousel';
import { getTopPlayerListFromFaction } from './getTopPlayerListFromFaction';

function FactionTopPlayers({ playersType, faction }) {
  const t = useTranslations();

  if (!faction) {
    return null;
  }

  const topPlayersList = getTopPlayerListFromFaction(faction, playersType);

  return (
    <div className="mb-5">
      {/* Mobile Version - Carousel */}
      <div className="block md:hidden">
        <div className="active-players-slider-container">
          {playersType === 'active' ? (
            <div className="mb-[30px] text-xl font-medium">
              {t('top_most_active_players')}
              <span className="text-chetwodeBlue text-sm">
                {' '}
                ({t('last30_battle_wins')})
              </span>
            </div>
          ) : (
            <div className="mb-[30px] text-xl font-medium">
              {t('top_strongest_members')}
              <span className="text-chetwodeBlue text-sm">
                {' '}
                ({t('by_roster_talent_all_time')})
              </span>
            </div>
          )}
          <div className="events-slider-container">
            <Carousel
              isFlooded
              className="block"
              opts={{ startIndex: 0, loop: true, containScroll: 'trimSnaps' }}
            >
              <CarouselContent
                className="ml-0 mr-0 pl-0 md:mr-0"
                containerClassName="md:overflow-hidden rounded-[10px]"
              >
                {topPlayersList.map((item, index) => (
                  <CarouselItem
                    key={index}
                    className="basis-full px-1 xl:max-w-[20rem]"
                    data-carousel-item
                  >
                    <FactionPlayerCard
                      playerInfo={item}
                      playerRank={index + 1}
                      wins={Number(item.wins || '0')}
                      isStrongest={playersType === 'active'}
                    />
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselIndicator className="mt-6 gap-0 md:hidden" />
            </Carousel>
          </div>
        </div>
      </div>

      {/* Desktop Version - Grid */}
      <div className="hidden md:block">
        {playersType === 'active' ? (
          <span className="text-xl font-medium">
            {t('top_most_active_players')}
            <span className="text-text600 text-sm">
              {' '}
              ({t('last30_battle_wins')})
            </span>
          </span>
        ) : (
          <span className="text-xl font-medium">
            {t('top_strongest_members')}
            <span className="text-text600 text-sm">
              {' '}
              ({t('by_roster_talent_all_time')})
            </span>
          </span>
        )}

        <div className="3xl:grid-cols-5 mt-[30px] grid grid-cols-3 gap-5">
          {topPlayersList.map((item, index) => {
            return (
              <div className="mb-[30px] xl:max-w-[20rem]" key={index}>
                <FactionPlayerCard
                  playerInfo={item}
                  playerRank={index + 1}
                  wins={Number(item.wins || '0')}
                  isStrongest={playersType === 'active'}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default FactionTopPlayers;
